import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DateTimePickerModule } from 'src/app/shared/components/date-time-picker/date-time-picker.module';
import { PageHeaderBtnComponent } from 'src/app/shared/components/page-header-btn/page-header-btn.component';
import { TranslationModule } from '../../../../i18n/translation.module';
import { SmsBodyModule } from '../../../../shared/components/sms-body/sms-body.module';
import { ShareModule } from '../../../../shared/share.module';
import { PagesSharedModule } from '../../../shared/pages-shared.module';
import { BaseSendSmsComponent } from './base-send-sms.component';
import { PhonebookSelectorComponent } from '../../../facility/phonebook/phonebook-selector/phonebook-selector.component';

@NgModule({
  declarations: [BaseSendSmsComponent],
  imports: [
    CommonModule,
    ShareModule,
    TranslationModule,
    ReactiveFormsModule,
    FormsModule,
    SmsBodyModule,
    PagesSharedModule,
    DateTimePickerModule,
    PageHeaderBtnComponent,
    PhonebookSelectorComponent
  ],
  exports: [BaseSendSmsComponent],
})
export class BaseSendSmsModule {}
